import { useEffect } from 'react';

export const SITE_URL = 'https://www.yayfuninc.com';

function setMeta(attr, key, content) {
    let tag = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
    }
    tag.setAttribute('content', content);
}

// Sets per-route title, description, canonical, and social tags for the SPA.
function useDocumentMeta({ title, description, path = '/', noindex = false }) {
    useEffect(() => {
        const url = SITE_URL + path;
        document.title = title;
        setMeta('name', 'description', description);
        setMeta('name', 'robots', noindex ? 'noindex, follow' : 'index, follow');
        setMeta('property', 'og:title', title);
        setMeta('property', 'og:description', description);
        setMeta('property', 'og:url', url);
        setMeta('name', 'twitter:title', title);
        setMeta('name', 'twitter:description', description);

        let canonical = document.head.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement('link');
            canonical.setAttribute('rel', 'canonical');
            document.head.appendChild(canonical);
        }
        canonical.setAttribute('href', url);
    }, [title, description, path, noindex]);
}

export default useDocumentMeta;
